import { FiltersContainer, FiltersContainerTitle } from 'components/Filter/Filter.styled'
import { IFilter, SingleFilter } from 'components/Filter/SingleFilter'
import { useEffect, useRef, useState } from 'react'
import { Button, Flex } from 'styling/GlobalStyles'
import { Head2 } from 'styling/Typography'
import { extractSelectedOptions, removeNullProperties } from 'utils/helpers'

export const Filter = ({ filterOptions, params, setParams, closeFilter, enableTemporaryManualClosing, visibleFilterOverflow }: IFilterProps) => { // TODO Visible overflow da se izbaci, mora automatski da se resi
    const [selectedOptions, setSelectedOptions] = useState(extractSelectedOptions())
    const optionsRef = useRef(null)

    // visibleFilterOverflow sluzi da se filteru dozvoli 
    // da ne isece opcije u Select komponenti koje izlaaze 
    // van okvira filtera, ovo se mora nekako resiti kasnije


    const handleSave = (values?: any) => {
        setParams((prev) => {
            let copy = structuredClone(prev)
            if (typeof values == 'object') {
                copy = { ...copy, ...removeNullProperties(values) }
            } else {
                copy = { ...copy, ...selectedOptions }
            }
            copy.page = 1
            return copy
        })
    }



    useEffect(() => {
        document.addEventListener('keydown', hideOnEscape, true)
        enableTemporaryManualClosing && document.addEventListener('click', hideOnClickOutside, true)
    }, [])

    const hideOnEscape = (e) => {
        if (e.key === 'Escape') {
            closeFilter()
        }
    }
    const hideOnClickOutside = (e) => {
        if (optionsRef.current && !optionsRef.current.contains(e.target)) {
            closeFilter()
        }
    }


    return <FiltersContainer ref={optionsRef} visibleFilterOverflow={visibleFilterOverflow} >
        <FiltersContainerTitle>
            <Head2 color='#ff9900' >Filters</Head2>


        </FiltersContainerTitle>

        <div style={{ display: 'flex', flexDirection: 'column' }}>
            {filterOptions?.map((o, i) => (
                <SingleFilter
                    filterOptions={o.filterOptions}
                    key={i}
                    filterParams={selectedOptions}
                    setFilterParams={setSelectedOptions}
                    link={o.link}
                    handleSave={handleSave}
                    name={o.name}
                    single={o.single}
                    type={o.type}
                    sd={o.sd}
                    companyId={o.companyId}
                    propName={o.propName}
                    selectOptions={o.options}
                    pageParams={params}
                    setPageParams={setParams}
                />
            ))}
        </div>
        <Flex mt='16' width='100%' justend >

            <Button onClick={() => handleSave()} orange >Save</Button>
        </Flex>
    </FiltersContainer>
}

interface IFilterProps {
    filterOptions: IFilter[]
    params: any
    setParams: React.Dispatch<React.SetStateAction<any>>
    closeFilter: () => void
    enableTemporaryManualClosing?: boolean
    visibleFilterOverflow?: boolean
}